<template>
  <GlobalEvents v-if="openPopUps[openPopUps.length - 1] === popupHash" @keydown.esc="closePopUp" />
  <slot name="activator" :show-pop-up="showPopUp" />
  <teleport to="body">
    <div
      v-if="openPopUps.includes(popupHash)"
      class="fixed inset-0 z-40 flex items-center justify-center overflow-y-auto bg-transparent/80 p-xl text-lightSecondaryTextColor dark:text-darkSecondaryTextColor"
      @mousedown="closePopUp"
    >
      <WrapperBox
        class="flex h-fit max-h-full w-fit min-w-[20rem] max-w-full flex-col md:min-w-[30rem]"
        :class="{ 'h-full w-full': props.isFullScreen }"
        @mousedown.stop
      >
        <div>
          <div class="mb-lg flex items-center text-xl font-bold md:mb-xl">
            <slot name="header">
              <HeaderText class="overflow-hidden text-ellipsis !text-3xl md:text-4xl">
                {{ props.title }}
              </HeaderText>
            </slot>
            <div class="grow" />
            <slot name="closeButton" :close-pop-up="closePopUp">
              <IconButton
                class="!h-4 w-4 min-w-4 dark:invert"
                :icon="Icon.CLOSE_V2"
                :tooltip-text="$t('dialog.close')"
                @click="closePopUp"
              />
            </slot>
          </div>
        </div>
        <div class="h-full overflow-auto">
          <slot :close-pop-up="closePopUp" :show-pop-up="showPopUp" />
        </div>
      </WrapperBox>
    </div>
  </teleport>
</template>
<script lang="ts">
const openPopUps = reactive<string[]>([]);
export default {
  name: "ModalDialog",
  inheritAttrs: false,
  customOptions: {},
};
</script>

<script setup lang="ts">
import { reactive } from "vue";

import { v4 as uuidv4 } from "uuid";
import { Icon } from "../assets/icons/Icon";
import HeaderText from "../components/HeaderText.vue";
import IconButton from "../components/IconButton.vue";
import WrapperBox from "../components/WrapperBox.vue";

const popupHash = uuidv4();

const props = defineProps<{
  title?: undefined | string;
  isFullScreen?: boolean;
}>();

const emit = defineEmits<{
  onOpen: [];
  onClose: [];
}>();

defineExpose({
  showPopUp,
  closePopUp,
});

function showPopUp() {
  openPopUps.push(popupHash);
  emit("onOpen");
}

function closePopUp() {
  // Remove current and all popups after it from the array
  const indexOfPopup = openPopUps.indexOf(popupHash);
  if (indexOfPopup === -1) {
    return;
  }

  openPopUps.splice(indexOfPopup, openPopUps.length - indexOfPopup);
  emit("onClose");
}
</script>
